  import { configureStore } from "@reduxjs/toolkit";
import userSlice from "./user/user.reducer";
import providerSlice from "./provider/provider.reducer";
import foodSlice from "./food/food.reducer";
import orderSlice from "./order/order.reducer";
import reviewSlice from "./review/review.reducer";
import otpSlice from "./otp/otp.reducer";
import  cartSlice,{ subscribeToCartChanges }  from "./Cart/Cart.reducer";

export const store = configureStore({
  reducer: {
    user: userSlice,
    provider: providerSlice,
    foods: foodSlice,
    orders: orderSlice,
    reviews: reviewSlice,
    cart: cartSlice,
    otp: otpSlice
  },
});

subscribeToCartChanges(store);